module.exports = __webpack_public_path__ + "img/plus-grey.3ac28f37.svg";